module.exports = __webpack_public_path__ + "static/texture-light-e509681cb998ec9c174ecf626d6718b9.png";